/**
 * FormField — thin wrapper around <Input /> that pairs label + input +
 * error into a single component for the auth forms. The Input itself
 * already renders label/error; this exists so feature code can reach
 * for one component name and stop thinking about layout.
 */

import { forwardRef } from 'react'
import type { InputHTMLAttributes } from 'react'

import { Input } from './Input'

interface FormFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Required so label/error can pair via htmlFor / aria-describedby. */
  id: string
  label: string
  error?: string
  /** Persistent helper text, shown when there is no error. */
  hint?: string
}

export const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  function FormField(props, ref) {
    return <Input ref={ref} {...props} />
  },
)
